const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

const parseDate = (value: string): { year: number, month: number, day: number } | null => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)

    if (!match) return null

    return { year: Number(match[1]), month: Number(match[2]) - 1, day: Number(match[3]) }
}

/** "2026-09-02" → "September 2, 2026". Parsed by hand so server and browser always agree. */
export const formatLongDate = (value: string): string => {
    const date = parseDate(value)

    if (!date) return value

    return `${MONTHS[date.month]} ${date.day}, ${date.year}`
}

/** "2026-09-02" → "Sep 2, 2026" */
export const formatShortDate = (value: string): string => {
    const date = parseDate(value)

    if (!date) return value

    return `${MONTHS[date.month].slice(0, 3)} ${date.day}, ${date.year}`
}

export const pad = (value: number, size = 2): string => String(value).padStart(size, '0')

/** "€480.00" → 480, used for sorting only */
export const priceValue = (price: string): number => {
    const numeric = Number.parseFloat(price.replace(/[^0-9.]/g, ''))

    return Number.isFinite(numeric) ? numeric : 0
}

export const isEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
